import { MultiSelect, MultiSelectProps } from '@mantine/core';
import React from 'react';

export const CustomMultiSelect = React.forwardRef<HTMLInputElement, MultiSelectProps>(({ styles, ...props }, ref) => {
  return (
    <MultiSelect
      ref={ref}
      withScrollArea={false}
      styles={{ dropdown: { maxHeight: 200, overflowY: 'auto' }, ...styles }}
      {...props}
    />
  );
});

CustomMultiSelect.displayName = 'CustomMultiSelect';
